export const LOAD_QUIZ_TAKE = 'LOAD_QUIZ_TAKE'
export const ANSWER_SELECTED = 'ANSWER_SELECTED'
export const SUBMIT_ANSWER = 'SUBMIT_ANSWER'
export const NEXT_QUESTION = 'NEXT_QUESTION'
export const GO_TO_THE_QUESTION = 'GO_TO_THE_QUESTION'
export const TRIGGER_STUDY_GUIDE_PLAYER = 'TRIGGER_STUDY_GUIDE_PLAYER'
export const CLOSE_SUCCESS_BANNER = 'CLOSE_SUCCESS_BANNER'
